module.exports = __webpack_public_path__ + "static/media/2023_5.e90a27b1.jpg";